// The corner's cards (While you were away, What's new) and the first-time tips take turns (fix round 1): while a card
// is on screen a tour does not start, and it starts once the card is put away, so a tip never covers the card.

import { useEffect } from "react";
import { create } from "zustand";

const useCards = create<{ up: number }>(() => ({ up: 0 }));

/** Called by a card while it is on screen. */
export function useHoldTips() {
  useEffect(() => {
    useCards.setState((s) => ({ up: s.up + 1 }));
    return () => useCards.setState((s) => ({ up: Math.max(0, s.up - 1) }));
  }, []);
}

/** Whether a corner card is on screen now. */
export const useCardUp = () => useCards((s) => s.up > 0);
